import { createReducer } from '@reduxjs/toolkit';

import {
  fetchListAction,
  createSpottedNoteAction,
  setVehicleModal,
  onFilterChange,
  fetchSpottedNotesAction,
  onSearch,
  setLoading,
  countOrderType,
  countListAction,
  countReachStatus,
  fetchMapData,
  handleRefetch,
  editSpottedNoteAction,
  updateOneColorInSNSAction,
} from './spotted-not-secured-actions';

import { SPOTTED_NOT_SECURED_INITIAL_STATE } from './spotted-not-secured-constants';
// import { SpottedNotSecuredState } from './spotted-not-secured-types';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any, react-refresh/only-export-components
export default createReducer<any>(SPOTTED_NOT_SECURED_INITIAL_STATE, (builder) => {
  builder
    // -- repo hit list --
    .addCase(fetchListAction.fulfilled, (state, action) => {
      return {
        ...state,
        skipAmount: action.payload.skipAmount,
        listData: action.payload.listData ?? [],
        listCount: action.payload.listCount ?? 0,
        hasSearched: false,
        loading: false,
      };
    })
    .addCase(setLoading, (state, action) => {
      return { ...state, loading: action.payload };
    })
    .addCase(fetchListAction.rejected, (state) => {
      return { ...state, listData: [], loading: false };
    })
    // -- handle refetch --
    .addCase(handleRefetch.fulfilled, (state, action) => {
      return {
        ...state,
        listData: action.payload.list,
        listCount: action.payload.count,
      };
    })
    .addCase(handleRefetch.rejected, (state) => {
      return state;
    })
    // -- create spotted note --
    .addCase(createSpottedNoteAction.pending, (state) => {
      return { ...state, createSpottedNoteLoading: true };
    })
    .addCase(createSpottedNoteAction.fulfilled, (state, action) => {
      return {
        ...state,
        createSpottedNoteLoading: false,
        listData: action.payload.list ?? [],
        vehicleModalSpottedNotesData:
          action.payload.vehicleModalSpottedNotesData || state.vehicleModalSpottedNotesData,
      };
    })
    .addCase(createSpottedNoteAction.rejected, (state) => {
      return { ...state, createSpottedNoteLoading: false };
    })
    // -- edit spotted note --
    .addCase(editSpottedNoteAction.pending, (state) => {
      return { ...state, createSpottedNoteLoading: true };
    })
    .addCase(editSpottedNoteAction.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload.spottedNotSecured,
        createSpottedNoteLoading: false,
      };
    })
    .addCase(editSpottedNoteAction.rejected, (state) => {
      return { ...state, createSpottedNoteLoading: false };
    })
    // -- fetch map data  --
    .addCase(fetchMapData.fulfilled, (state, action) => {
      return {
        ...state,
        mapData: action.payload ?? [],
      };
    })
    .addCase(fetchMapData.rejected, (state) => {
      return state;
    })
    // -- fetch spotted notes --
    .addCase(fetchSpottedNotesAction.pending, (state) => {
      return {
        ...state,
        fetchSpottedNotesLoading: true,
        vehicleModalSpottedNotesData: null,
      };
    })
    .addCase(fetchSpottedNotesAction.fulfilled, (state, action) => {
      return {
        ...state,
        fetchSpottedNotesLoading: false,
        vehicleModalSpottedNotesData: action.payload.spottedNotes ?? [],
      };
    })
    .addCase(fetchSpottedNotesAction.rejected, (state) => {
      return {
        ...state,
        fetchSpottedNotesLoading: false,
        vehicleModalSpottedNotesData: [],
      };
    })
    // -- count order type --
    .addCase(countOrderType.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
        loadingOrderTypeCounter: false,
      };
    })
    .addCase(countOrderType.pending, (state) => {
      return {
        ...state,
        loadingOrderTypeCounter: true,
      };
    })
    // -- count reach status --
    .addCase(countReachStatus.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    })
    .addCase(countReachStatus.rejected, (state) => {
      return state;
    })
    // -- count total  --
    .addCase(countListAction.fulfilled, (state, action) => {
      return { ...state, totalCount: action.payload };
    })
    .addCase(countListAction.rejected, (state) => {
      return { ...state, totalCount: 0 };
    })
    // -- simple actions --
    .addCase(setVehicleModal, (state, action) => {
      return { ...state, vehicleModalData: action.payload };
    })
    .addCase(onSearch, (state, action) => {
      return { ...state, skipAmount: 0, searchQuery: action.payload };
    })
    .addCase(onFilterChange, (state) => {
      return {
        ...SPOTTED_NOT_SECURED_INITIAL_STATE,
        loadingOrderTypeCounter: state.loadingOrderTypeCounter,
        allOrderTypeCount: state.allOrderTypeCount,
        voluntaryCount: state.voluntaryCount,
        involuntaryCount: state.involuntaryCount,
        impoundCount: state.impoundCount,
        totalCount: state.totalCount,
        obstructedCount: state.obstructedCount,
        accessibleCount: state.accessibleCount,
      };
    })
    .addCase(updateOneColorInSNSAction.fulfilled, (state, action) => {
      return {
        ...state,
        listData: action.payload.repoHitList,
      };
    })
    // -- default --
    .addDefaultCase((state) => state);
});
